// extracted by mini-css-extract-plugin
export default {"headerContent":"TopHeader_headerContent__yrWcr","title":"TopHeader_title__FH5mc"};